import SearchIcon from "@mui/icons-material/Search";
import { IconButton } from "@mui/material";
import PropTypes from "prop-types";

const SearchButton = (props) => {
  return (
    <IconButton
      size="small"
      className="search-icon-button"
      onMouseDown={() => props.onSearchSubmit(props.searchString)}
    >
      <SearchIcon />
    </IconButton>
  );
};

SearchButton.propTypes = {
  onSearchSubmit: PropTypes.func.isRequired,
  searchString: PropTypes.string.isRequired,
};

export default SearchButton;
